import { Box, Drawer } from "@mui/material";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import React from "react";

////////////////////////////////////////////////////////////////////////////////

interface OutsideRightPanelProps {
    open?: boolean;
    content?: React.ReactNode;
    onClose: () => void;
}

export const OutsideRightPanel = ({ open = true, content, onClose }: OutsideRightPanelProps) => {
    const c = React.Children.toArray(content);
    return (
        <Drawer
            open={open}
            anchor="right"
            onClose={onClose}
        >
            <Box display="flex" flexDirection="column" rowGap={3} sx={{ width: "300px", p: 1 }}>
                {
                    c.map((child, index) => {
                        return (
                            <Box key={index} className={AppGlobalClassKeys.hiddenIfEmpty}>
                                {child}
                            </Box>
                        );
                    })
                }
            </Box>
        </Drawer>
    );
};
